import { IDataFileVisitor } from './IDataFileVisitor.js';
import {
  Doc,
  DocCompatibilityTable,
  DocExternalField,
  DocJsFilter,
  DocOclConstraint,
  DocOclFilter,
  DocOption,
  DocOptionGroup,
  DocProduct,
  DocProductGroup
} from './DataFile.js';
import { YamlTransformer } from '../YamlTransformer.js';

export class PostprocessingProductVisitor implements IDataFileVisitor {
  constructor(private readonly transformer: YamlTransformer) {
  }

  visitCompatibilityTable(doc: DocCompatibilityTable): void {
  }

  visitExternalFiled(doc: DocExternalField): void {
  }

  visitJsFilter(doc: DocJsFilter): void {
  }

  visitOclConstraint(doc: DocOclConstraint): void {
  }

  visitOclFilter(doc: DocOclFilter): void {
  }

  visitOption(doc: DocOption): void {
  }

  visitOptionGroup(doc: DocOptionGroup): void {
  }

  visitProduct(doc: DocProduct): void {
    this.transformer.postProcessProduct(doc);
  }

  visitProductGroup(doc: DocProductGroup): void {
  }

  visitUnknown(doc: Doc): void {
  }

  beforeAll(): void {
  }

  afterAll(): void {
  }
}